var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"multi"},[_c('article',{staticClass:"multicity__Widget"},[_c('Multicity',{attrs:{"booking-data":_vm.$store.getters.getBookingData,"display-target":_vm.$store.getters.displayTarget}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }